module.exports = {
    storage: {
        idToken : "idtoken",
        accessToken : "accesstoken",
        refreshToken : "refreshtoken",
        expiry : "expiry",
        user: "user",        
        loggedIn : "lis",
        agreeCookies : "agreecookies"
    },
    apiContext: {
        user : "user"
    },
    anon : {
        username : "anonymous-user"
    },
    loggedInStatus: {
        loggedOut: "0",
        loggedIn : "1",
        expired :"2",
        confirm : "3",
        loggedInAnon : "4"
    },
    scenario : {
        noId : '-1'
    },
    site : {
        sitename : "TNS",
        siteurl : "www.tnx-123-abc.com",
        siteemail : "info@tns.com"
    },
    error : {
        generalMessage : "There was a problem, please try again"
    },
    queryparams : {
        question : "question",
        country : "country"
    },
    localStorage :{
        countrypref : "countrypref",
        selectedcountry : "selectedcountry",
        sharedquestion : "sharedquestion",
        // Conversation thread for the AgentCore front door. Replaces the old
        // ad-hoc "kendra_session_id" key. Note this is a THREAD id now, not a
        // session id: the server namespaces it under the authenticated user
        // and derives the real runtimeSessionId itself, so this value is no
        // longer sufficient to address a conversation on its own.
        threadId : "tnsiq_thread_id"
    }

}